import axios from "@/axios.config";

class ParticipationService {
    enterExam(cancelToken, examId) {
        return axios
            .post(`exams/${examId}/!enter`, {}, {cancelToken: cancelToken.token})
            .then((response) => {
                return response.data
            })
    }

    finishExam(cancelToken, examId) {
        return axios
            .post(`exams/${examId}/!finish`, {}, {cancelToken: cancelToken.token})
            .then((response) => {
                return response.data
            })
    }

    getQuestion(cancelToken, examId, questionId) {
        return axios
            .get(`exams/${examId}/questions/${questionId}`, {cancelToken: cancelToken.token})
            .then((response) => {
                return response.data
            })
    }

    submitAnswer(cancelToken, examId, questionId, answer) {
        return axios
            .patch(`exams/${examId}/questions/${questionId}/interaction`, {
                option_id: answer?.optionId,
                content: answer?.content,
                file_id: answer?.fileId,
            }, {cancelToken: cancelToken.token})
            .then((response) => {
                return response.data
            })
    }
}

export default new ParticipationService()